export type PrescriptionSmsResult = {
  success: boolean
  error?: string
}

export const sendPrescriptionSms = async (
  mobileNumber: string,
  messageType: string
): Promise<PrescriptionSmsResult> => {
  const response = await fetch("/api/prescription", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ mobileNumber, messageType })
  })

  const body = await response.json().catch(() => ({}))

  if (!response.ok) {
    return { success: false, error: body.error ?? body.message }
  }

  return { success: body.success === true, error: body.error }
}
